import { createElement } from 'react';

import { Controller } from '@hotwired/stimulus';
import { createRoot } from 'react-dom/client';

import { getMetaContent, isFeatureFlagEnabled } from '../lib/meta';

import LogViewer from '../components/LogViewer';

export default class extends Controller {
  static values = {
    visible: { type: Boolean, default: false },
  };

  initialize() {
    // Load persisted visible state from localStorage
    const savedVisible = localStorage.getItem('logViewer.visible');
    this.visibleValue = savedVisible === 'true';
  }

  connect() {
    // always enable on dev/staging, or if debug feature flag is enabled
    if (['development', 'staging'].includes(getMetaContent('build:environment')) || isFeatureFlagEnabled('debug')) {
      this.container = document.createElement('div');
      this.container.id = 'log-viewer-container';
      this.container.className = 'fixed z-(--stack-flashes)';
      document.body.appendChild(this.container);

      this.root = createRoot(this.container);
      this.render();
    }
  }

  disconnect() {
    if (this.root) this.root.unmount();

    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }

  toggle() {
    this.visibleValue = !this.visibleValue;
    this.render();
  }

  show() {
    this.visibleValue = true;
    this.render();
  }

  hide() {
    this.visibleValue = false;
    this.render();
  }

  render() {
    if (!this.root) return;
    this.root.render(createElement(LogViewer, { isVisible: this.visibleValue, onClose: () => this.hide() }));
  }

  visibleValueChanged() {
    if (this.root) this.render();
    localStorage.setItem('logViewer.visible', this.visibleValue.toString());
  }
}
